// TanStack Router adapter for vidmax-vite
import { useLocation, useNavigate, useRouter } from "@tanstack/react-router"
import type { NavigationContextType, UiRouter } from "@aix/ui/src/router"
import { Link, Image } from "./tanstackNavigationComponents"

function useRouterAdapter(): UiRouter {
  const location = useLocation()
  const navigate = useNavigate()
  const router = useRouter()

  // Parse query params from search string
  const searchParams = new URLSearchParams(location.search)
  const query: Record<string, string | string[]> = {}

  for (const [key, value] of searchParams.entries()) {
    if (query[key]) {
      // Handle multiple values for the same key
      if (Array.isArray(query[key])) {
        query[key].push(value)
      } else {
        query[key] = [query[key], value]
      }
    } else {
      query[key] = value
    }
  }

  return {
    pathname: location.pathname,
    query,
    push: (url) => {
      void navigate({ to: url })
    },
    replace: (url) => {
      void navigate({ to: url, replace: true })
    },
    back: () => window.history.back(),
    forward: () => window.history.forward(),
  }
}

function useIsActive(path: string, opts?: { exact?: boolean }) {
  const location = useLocation()
  const pathname = location.pathname
  return opts?.exact ? pathname === path : pathname.startsWith(path)
}

export const tanstackNavigationAdapter: NavigationContextType = {
  Link,
  Image,
  useRouter: useRouterAdapter,
  useIsActive,
}
